import React from 'react';
import { Hash, Users } from 'lucide-react';
import { cn } from '@/lib/utils';
import getAvatarColor from '@/utils/getAvatarColor';
import UserAvatar from './UserAvatar';

/**
 * The avatar for a team conversation: the other person for a direct message,
 * a # for a channel and a group icon otherwise, on a colour taken from the name.
 * `size` is in pixels.
 */
const TeamConversationAvatar = ({
	conversation,
	directMessageUser,
	size = 40,
	className,
}) => {
	if (directMessageUser) {
		return (
			<div className={cn('shrink-0', className)} style={{ width: size, height: size }}>
				<UserAvatar
					user={directMessageUser}
					showName={false}
					showNameBelow={false}
					avatarWidth={`${size}px`}
					avatarHeight={`${size}px`}
					avatarFontSize={size >= 40 ? '15px' : '13px'}
				/>
			</div>
		);
	}

	const Icon = conversation?.channel ? Hash : Users;

	return (
		<div
			aria-hidden="true"
			className={cn(
				'flex shrink-0 items-center justify-center rounded-full text-white',
				className
			)}
			style={{
				width: size,
				height: size,
				backgroundColor: getAvatarColor(conversation?.title || conversation?._id),
			}}
		>
			<Icon style={{ width: size * 0.42, height: size * 0.42 }} strokeWidth={2} />
		</div>
	);
};

export default TeamConversationAvatar;
